import { SearchPreferencesSerializer } from './serializer';
import type { SearchPreferencesDTO, SearchPreferencesScopeDTO } from './dto';
import { SearchPreferences } from './searchPreferences';
import { applyDefaults, type SearchPreferenceDefaults } from './applyDefaults';

export class SearchPreferencesFactory {
  readonly #serializer: SearchPreferencesSerializer;

  constructor(serializer = new SearchPreferencesSerializer()) {
    this.#serializer = serializer;
  }

  /**
   * The visitor's preferences, with any profile defaults filled in where the
   * DTO holds nothing.
   *
   * `defaults` is required, and deliberately so. Defaulting used to be a
   * second call every reader had to remember; forgetting it is a mistake with
   * no symptom -- the visitor simply gets the wrong filter. Required means a
   * caller has to say which it wants rather than getting the unsafe one by
   * omission.
   *
   * Pass `{}` for the stored form. That is what a writer wants: a defaulted
   * value handed to `toScopeDTO` would persist the default as though the
   * visitor had chosen it, which is the ratchet this workstream opened with.
   */
  fromDTO = (
    dto: SearchPreferencesDTO,
    defaults: SearchPreferenceDefaults
  ): SearchPreferences =>
    applyDefaults(this.#serializer.deserialize(dto), defaults);

  // Scopes only — see SearchPreferencesSerializer#serializeScopes for why
  // the global fields are deliberately not produced.
  toScopeDTO = (preferences: SearchPreferences): SearchPreferencesScopeDTO =>
    this.#serializer.serializeScopes(preferences);
}
